

export const renderMusic = (music) => {
    let stopMusicButton = window.$("#btn-stop-music");
    stopMusicButton.prop('disabled', true);
    if (!music)
        music = 'https://cdns-preview-d.dzcdn.net/stream/c-deda7fa9316d9e9e880d2c6207e92260-8.mp3';
    return new window.Howl({
        //edit this to the music you want to play
        src: [music],
        onend: function () {
            stopMusicButton.prop('disabled', false);
        }
    });
}


